// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Date-module--cls1--1VSJI","cls2":"styles-Date-module--cls2--38kx1 styles-Date-module--cls1--1VSJI"};